// src/pages/Examiner/JobDetails.js
import React, { useState, useEffect } from 'react';
import { Container, Card, Button, Form, Alert, Spinner } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import TitleWithBack from '../../components/common/TitleWithBack';

function JobDetails() {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [cancelReason, setCancelReason] = useState('');
  const [actionError, setActionError] = useState(null);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`/api/exam-assignments/${jobId}`)
      .then(response => {
        setJob(response.data);
        setLoading(false);
      })
      .catch(err => {
        setError('Error fetching assignment details.');
        setLoading(false);
      });
  }, [jobId]);

  const handleApprove = () => {
    axios
      .post(`/api/exam-assignments/${jobId}/approve`)
      .then(() => {
        navigate(-1);
      })
      .catch(() => {
        setActionError('Error approving assignment.');
      });
  };

  const handleReject = () => {
    if (!cancelReason) {
      setActionError('Please provide a reason for cancellation.');
      return;
    }
    axios
      .post(`/api/exam-assignments/${jobId}/cancel`, { reason: cancelReason })
      .then(() => {
        navigate(-1);
      })
      .catch(() => {
        setActionError('Error cancelling assignment.');
      });
  };

  if (loading) {
    return (
      <Container className="mt-3 text-center">
        <Spinner animation="border" variant="primary" />
      </Container>
    );
  }
  if (error) {
    return <Alert variant="danger" className="mt-3">{error}</Alert>;
  }
  if (!job) {
    return <Alert variant="info" className="mt-3">Nothing to show here</Alert>;
  }

  return (
    <Container className="mt-2">
      <TitleWithBack title="Assignment Details" level="h2" />
      <Card>
        <Card.Body>
          <Card.Text>
            <strong>Assigned By:</strong> {job.assignedBy}<br />
            <strong>Module Name:</strong> {job.moduleName}<br />
            <strong>Module Code:</strong> {job.moduleCode}<br />
            <strong>Exam Date:</strong> {new Date(job.examDate).toLocaleDateString()}<br />
            <strong>Assigned On:</strong> {new Date(job.assignedDate).toLocaleDateString()}<br />
            <strong>Deadline:</strong> {new Date(job.deadline).toLocaleDateString()}<br />
            <strong>Status:</strong> {job.status}
          </Card.Text>
          {actionError && <Alert variant="danger">{actionError}</Alert>}
          {(job.status === 'PENDING' || job.status === 'ASSIGNED') && (
            <>
              <div className="d-flex flex-wrap mb-2">
                <Button variant="success" size="sm" className="me-2" onClick={handleApprove}>
                  Approve
                </Button>
                <Button variant="danger" size="sm" className="me-2" onClick={handleReject}>
                  Reject
                </Button>
              </div>
              <Form.Group>
                <Form.Label>Reason for cancellation:</Form.Label>
                <Form.Control
                  type="text"
                  value={cancelReason}
                  onChange={(e) => setCancelReason(e.target.value)}
                  placeholder="Enter reason..."
                />
              </Form.Group>
            </>
          )}
        </Card.Body>
      </Card>
      <Button variant="secondary" className="mt-3" onClick={() => navigate(-1)}>
        Back to Dashboard
      </Button>
    </Container>
  );
}

export default JobDetails;
